window.addEventListener("load", function(event) {
    const cards = document.querySelector('[data-cards="featured-blog"]');
    const thumb = document.querySelector('[data-scroll-thumb="featured-blog"]');

    function updateThumb() {
        const ratio = cards.clientWidth / cards.scrollWidth;
        thumb.style.width = `${ratio * cards.clientWidth}px`;

        const offset = cards.scrollLeft / cards.scrollWidth;
        thumb.style.transform = `translateX(${offset * cards.clientWidth}px)`;
    }

    cards.addEventListener("scroll", updateThumb);
    window.addEventListener("resize", updateThumb);
    updateThumb();
});